// extracted by mini-css-extract-plugin
export var chevron = "_j2-3";
export var chevronRotated = "_j2-4";
export var image = "_j2-1";
export var imageContainer = "_j2-0";
export var shippingAddress = "_j2-2";